/**
 * AnnouncementIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const AnnouncementIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M21.05 2.298a2 2 0 0 0-1.94-.09l-6.35 3.17H7a5 5 0 0 0-1.33 9.82l-1.4 4.18c-.148.458-.07.96.21 1.35a1.49 1.49 0 0 0 1.21.65h3a1.48 1.48 0 0 0 1.42-1l1.66-5h1l6.35 3.17a2 2 0 0 0 2.89-1.79V3.998a2 2 0 0 0-.96-1.7M4 10.378a3 3 0 0 1 3-3h5v6H7a3 3 0 0 1-3-3m4.28 9H6.39l1.33-4h1.89zm5.72-5.62v-6.76l6-3v12.76z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const AnnouncementIcon = makeIcon('AnnouncementIcon', AnnouncementIconSvg)
